import { render, staticRenderFns } from "./showForm.vue?vue&type=template&id=8c0ccde0&"
import script from "./showForm.vue?vue&type=script&lang=js&"
export * from "./showForm.vue?vue&type=script&lang=js&"
import style0 from "./showForm.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports